"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingProvenance = exports.TrackingEvents = exports.ShipmentUnassignmentReason = void 0;
var ShipmentUnassignmentReason;
(function (ShipmentUnassignmentReason) {
    ShipmentUnassignmentReason["FreightNotReady"] = "freightNotReady";
})(ShipmentUnassignmentReason = exports.ShipmentUnassignmentReason || (exports.ShipmentUnassignmentReason = {}));
var TrackingEvents;
(function (TrackingEvents) {
    TrackingEvents["StatusUpdated"] = "statusUpdated";
    TrackingEvents["ShipmentBooked"] = "shipmentBooked";
})(TrackingEvents = exports.TrackingEvents || (exports.TrackingEvents = {}));
var TrackingProvenance;
(function (TrackingProvenance) {
    TrackingProvenance["Mothership"] = "mothership";
    TrackingProvenance["IntegratedCarrier"] = "integratedCarrier";
})(TrackingProvenance = exports.TrackingProvenance || (exports.TrackingProvenance = {}));
//# sourceMappingURL=tracking.js.map